import { Box } from "@mui/material";

export default function AlertaRetornoDeDados() {
  return (
    <Box display="flex" flex={1} alignItems="center" justifyContent="center" fontSize={14} fontWeight={700}>
      Não foram encontrados dados
    </Box>
  );
}
